import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StyledAltIconButton } from "../../../../styles/ButtonStyles";
import Select from "../Select";
import { faQuestion } from "@fortawesome/free-solid-svg-icons";

function IconSelect({
  value,
  options,
  onChange,
  icon = (val) => null,
  disabled,
  title,
  style,
  as = StyledAltIconButton,
}) {
  return (
    <Select
      value={value}
      options={options}
      onChange={onChange}
      title={title}
      disabled={disabled}
      hideCaret={true}
      searchable={false}
      as={as}
      valueVisual={(val) => icon(val) ?? <FontAwesomeIcon icon={faQuestion} />}
      style={style}
    />
  );
}

export default IconSelect;
